import { EQEnrichedCourseSections } from "services/shortAnswerService/question-types/QuestionCourseSections";

import shuffle from "seneca-common/utils/functions/random/shuffle";

import {
  FlatSectionWithQuestion,
  getOneQuestionFromEachSectionOnCondition,
  groupQuestionBySection,
  removeDuplicateQuestions,
  SectionWithQuestions,
  SectionWithSubSections
} from "./general";

export function availableQuestionsForSections(
  sectionsWithSubSections: SectionWithSubSections[],
  allCourseQuestions: EQEnrichedCourseSections[]
) {
  const leafSubSectionIds = sectionsWithSubSections.flatMap(
    sectionWithSubSections => sectionWithSubSections.leafSubSectionIds
  );

  function getQuestionSectionId(question: EQEnrichedCourseSections) {
    const leafSubSectionId = leafSubSectionIds.find(leafSubSectionId => {
      return question.courseSections.find(courseSection => {
        return courseSection.sectionIds.find(
          sectionId => sectionId === leafSubSectionId
        );
      });
    });

    const sectionWithSubSections = sectionsWithSubSections.find(topic => {
      return topic.leafSubSectionIds.includes(leafSubSectionId as string);
    });

    return sectionWithSubSections?.sectionId;
  }

  return allCourseQuestions.flatMap(question => {
    const maybeSectionId = getQuestionSectionId(question);

    if (maybeSectionId) {
      return [
        {
          sectionId: maybeSectionId,
          question: question
        }
      ];
    } else {
      return [];
    }
  });
}

export function getShuffledQuestionsFromSubTopics(
  sectionsWithSubSections: SectionWithSubSections[],
  allCourseQuestions: EQEnrichedCourseSections[],
  numberOfQuestions?: number
): SectionWithQuestions[] {
  const questionsWithSectionId = availableQuestionsForSections(
    sectionsWithSubSections,
    allCourseQuestions
  );
  return getShuffledQuestions(questionsWithSectionId, numberOfQuestions);
}

export function getShuffledQuestions(
  questionsWithSectionId: FlatSectionWithQuestion[],
  numberOfQuestions?: number
) {
  const shuffledQuestionsWithSectionId = shuffle(questionsWithSectionId);
  const selectedQuestions = questionsWithSectionId.filter(
    question => question.selected
  );

  const firstQuestions = getOneQuestionFromEachSectionOnCondition(
    shuffledQuestionsWithSectionId,
    question =>
      !selectedQuestions.find(
        q =>
          q.sectionId === question.sectionId ||
          q.question.questionId === question.question.questionId
      )
  );

  const questionsWithoutDuplicates = removeDuplicateQuestions([
    ...selectedQuestions,
    ...firstQuestions,
    ...shuffledQuestionsWithSectionId
  ]);

  const totalQuestions =
    numberOfQuestions !== undefined
      ? questionsWithoutDuplicates.slice(0, numberOfQuestions)
      : questionsWithoutDuplicates;

  return groupQuestionBySection(totalQuestions);
}
